export interface OnboardingGuideInterface {
    buttonProgressBar?: OnboardingGuideInterfaceButton;
    buttonPrev?: OnboardingGuideInterfaceButton;
    buttonNext?: OnboardingGuideInterfaceButton;
    buttonRememberLogin?: OnboardingGuideInterfaceButton;
    buttonNeverShowAgain?: OnboardingGuideInterfaceButton;
    buttonStartGuide?: OnboardingGuideInterfaceButton;
    buttonCloseGuide?: OnboardingGuideInterfaceButton;
    buttonFinishGuide?: OnboardingGuideInterfaceButton;
    steps: OnboardingGuideInterfaceStep[];
}

export interface OnboardingGuideInterfaceStep {
    type: "intro" | "table-of-contents" | "content";
    headline?: string;
    subline?: string;
    text?: string;
    hint?: string;
    machines?: OnboardingGuideInterfaceMachine[];
    mediaElements?: OnboardingGuideInterfaceMediaElement[];
    buttons?: OnboardingGuideInterfaceButton[];
}

export interface OnboardingGuideInterfaceMachine {
    name?: string;
    number?: string;
    imageSrc?: string;
    button?: OnboardingGuideInterfaceButton;
}

export interface OnboardingGuideInterfaceMediaElement {
    type: "image" | "video";
    url: string;
    alt?: string;
    caption?: string;
}

export interface OnboardingGuideInterfaceButton {
    label?: string;
    variant?: "default" | "primary" | "no-border";
    url?: string;
}

export interface OnboardingGuideInterfaceRememberLogin {
    success?: boolean;
}

export interface OnboardingGuideInterfaceNeverShowAgain {
    success?: boolean;
}
